import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessSessionsRoute: InvariantJiraRoute = {
	name: 'classic-business-sessions',
	path: '/jira/core/projects/:projectKey/sessions',
	exact: true,
};
